export default "__VITE_ASSET__C3mE27cD__"